import { memo } from 'react'
import { formatPrice } from '../lib/formatPrice'

function GiftCard({ gift, onOpen, onPreload }) {
  const handlePointerDown = () => {
    if (typeof onPreload === 'function') {
      onPreload(gift)
    }
  }

  const handleClick = () => {
    if (typeof onOpen === 'function') {
      onOpen(gift)
    }
  }

  const handlePreviewError = () => {
    console.error('[GiftCard] preview_svg failed to load:', gift.preview_svg)
  }

  return (
    <button
      type="button"
      aria-label={`${gift.name}, ${formatPrice(gift.price)} рублей`}
      onPointerDown={handlePointerDown}
      onClick={handleClick}
      className="home-figma-card relative aspect-square h-auto w-full cursor-pointer overflow-hidden rounded-2xl p-3"
    >
      <div className="pointer-events-none h-full w-full">
        <img loading="eager"
          src={gift.preview_svg}
          alt={gift.name}
          decoding="async"
          className="h-full w-full object-contain"
          onError={handlePreviewError}
        />
      </div>

      <span
        className="pointer-events-none absolute -right-[39px] top-[18px] flex h-7 w-[150px] rotate-45 items-center justify-center whitespace-nowrap bg-accent px-2 text-center text-[13px] font-semibold leading-none tabular-nums text-white shadow-md shadow-black/25"
        aria-hidden="true"
      >
        {formatPrice(gift.price)} ₽
      </span>
    </button>
  )
}

export default memo(GiftCard, (prevProps, nextProps) => (
  prevProps.onOpen === nextProps.onOpen
  && prevProps.onPreload === nextProps.onPreload
  && prevProps.gift.id === nextProps.gift.id
  && prevProps.gift.name === nextProps.gift.name
  && prevProps.gift.price === nextProps.gift.price
  && prevProps.gift.preview_svg === nextProps.gift.preview_svg
  && prevProps.gift.animation_url === nextProps.gift.animation_url
))
